import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./ContactPage.css";

export default function ContactPage() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    subject: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const contactMethods = [
    {
      icon: "📧",
      title: "Email Us",
      description: "Send us an email anytime",
      contact: "vivekgpm2024@gmail.com",
      action: "mailto:vivekgpm2024@gmail.com",
    },
    {
      icon: "📞",
      title: "Call Us",
      description: "Mon-Sat from 9am to 6pm",
      contact: "6363186060",
      action: "tel:+916363186060",
    },
    {
      icon: "📍",
      title: "Visit Us",
      description: "Come say hello at our office",
      contact:
        "Vishnu Avenue, Plot No. 17 & 18, Kritika Layout, Jaihind Enclave, Madhapur GST Office street, Street, Road, opposite Capital Park Road, Hyderabad, Telangana 500081",
      action: "#",
    },
  ];

  function validate() {
    const errs = {};
    if (!form.name.trim()) errs.name = "Name is required";
    if (!form.email.trim()) errs.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(form.email)) errs.email = "Email is invalid";
    if (!form.subject.trim()) errs.subject = "Subject is required";
    if (!form.message.trim()) errs.message = "Message is required";
    // if (form.phone && !/^\+?[\d\s\-\(\)]+$/.test(form.phone)) errs.phone = "Invalid phone number";
    return errs;
  }

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: undefined });
  }

  function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setSubmitted(true);
    const errs = validate();
    if (Object.keys(errs).length) {
      setErrors(errs);
      return;
    }

    // Build mailto link with subject & body
    const to = "vivekgpm2024@gmail.com";
    const subject = encodeURIComponent(
      form.subject || "New contact form message"
    );
    const body = encodeURIComponent(
      `Name: ${form.name}
Email: ${form.email}
Phone: ${form.phone}
Company: ${form.company}
Message:
${form.message}`
    );

    // Open default mail client
    window.location.href = `mailto:${to}?subject=${subject}&body=${body}`;

    // Show alert and reload page
    if (!alert("Email sent successfully.")) {
      window.location.reload();
    }
    setLoading(false);
    setSubmitted(false);
  }

  return (
    <div className="contact-page">
      {/* Navigation */}
      <nav className="contact-navbar">
        <div className="nav-container">
          <Link to="/" className="logo" alt='Back to Home' >
            {"<"}{" "}
            <img
              src="/assets/logovg.png"
              alt="Vachana Group Logo"
              className="logo-image"
            />
          </Link>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="contact-hero">
        <div className="contact-hero-background">
          <div className="angled-overlay"></div>
        </div>

        <div className="contact-hero-content">
          <div className="hero-text">
            <h1 className="hero-title">Get In Touch</h1>
            <p className="hero-subtitle">
              We'd love to hear from you! Reach out to discuss your project
              needs or learn more about our services.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Methods */}
      <section className="contact-methods">
        <div className="container">
          <div className="methods-grid">
            {contactMethods.map((method, index) => (
              <div key={index} className="method-card">
                <div className="method-icon">{method.icon}</div>
                <h3>{method.title}</h3>
                <p className="method-description">{method.description}</p>
                <a href={method.action} className="method-contact">
                  {method.contact}
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section id="contact-form" className="contact-form-section">
        <div className="container">
          <div className="form-container">
            <div className="form-header">
              <h2>Send us a Message</h2>
              <p>
                Fill out the form below and we'll get back to you as soon as
                possible
              </p>
            </div>

            {submitted ? (
              <div className="success-message">
                <div className="success-content">
                  <div className="success-icon">✅</div>
                  <h3>Message Sent Successfully!</h3>
                  <p>
                    Thank you for reaching out. We'll get back to you within 24
                    hours.
                  </p>
                </div>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-grid">
                  <div className="form-group">
                    <label htmlFor="name">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={form.name}
                      onChange={handleChange}
                      className={errors.name ? "error" : ""}
                      placeholder="Enter your full name"
                    />
                    {errors.name && (
                      <span className="error-message">{errors.name}</span>
                    )}
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      className={errors.email ? "error" : ""}
                      placeholder="Enter your email address"
                    />
                    {errors.email && (
                      <span className="error-message">{errors.email}</span>
                    )}
                  </div>

                  <div className="form-group">
                    <label htmlFor="phone">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={form.phone}
                      onChange={handleChange}
                      className={errors.phone ? "error" : ""}
                      placeholder="Enter your phone number"
                    />
                    {errors.phone && (
                      <span className="error-message">{errors.phone}</span>
                    )}
                  </div>

                  <div className="form-group">
                    <label htmlFor="company">Company</label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      value={form.company}
                      onChange={handleChange}
                      placeholder="Enter your company name"
                    />
                  </div>

                  <div className="form-group full-width">
                    <label htmlFor="subject">Subject *</label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      value={form.subject}
                      onChange={handleChange}
                      className={errors.subject ? "error" : ""}
                      placeholder="What's this about?"
                    />
                    {errors.subject && (
                      <span className="error-message">{errors.subject}</span>
                    )}
                  </div>

                  <div className="form-group full-width">
                    <label htmlFor="message">Message *</label>
                    <textarea
                      id="message"
                      name="message"
                      value={form.message}
                      onChange={handleChange}
                      className={errors.message ? "error" : ""}
                      placeholder="Tell us about your project or inquiry..."
                      rows="5"
                    />
                    {errors.message && (
                      <span className="error-message">{errors.message}</span>
                    )}
                  </div>
                </div>

                <div className="form-footer">
                  <button
                    type="submit"
                    className="submit-btn"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <div className="loading-spinner"></div>
                        Sending...
                      </>
                    ) : (
                      <>
                        Send Message
                        <span className="btn-arrow">→</span>
                      </>
                    )}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </section>

      {/* Additional Info Section */}
      <section className="additional-info">
        <div className="container">
          <div className="info-grid">
            <div className="info-card">
              <h3>Business Hours</h3>
              <div className="info-content">
                <div className="info-item">
                  <span className="day">Monday - Saturday</span>
                  <span className="time">9:00 AM - 6:00 PM</span>
                </div>
                <div className="info-item">
                  <span className="day">Sunday</span>
                  <span className="time">Closed</span>
                </div>
              </div>
            </div>

            <div className="info-card">
              <h3>Response Time</h3>
              <div className="info-content">
                <div className="response-item">
                  <span className="response-icon">📧</span>
                  <div>
                    <strong>Email Inquiries</strong>
                    <p>Within 24 hours</p>
                  </div>
                </div>
                <div className="response-item">
                  <span className="response-icon">📞</span>
                  <div>
                    <strong>Phone Calls</strong>
                    <p>Immediate during business hours</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
